module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Sport Aluminum + Green Closed.ce23a387.png";